import { Link } from "@remo-co/ui-core/src/components/Link";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { useI18n } from "i18n";
import { supportsSetSinkId } from "modules/deviceInfo";
import { selectOsName } from "modules/systemCheck/redux/selectors";
import { getMicCamTroubleshootLink } from "modules/systemCheck/utils/getMicCamTroubleshootLink";
import { useSelector } from "react-redux";
import { useStyles } from "./styles";

export const HelpLinks = () => {
  const { t } = useI18n(["common", "micCamCheck", "url"]);
  const os = useSelector(selectOsName);
  const styles = useStyles();
  const canChangeSpeakers = supportsSetSinkId();
  return (
    <Container>
      <Link
        openInNewTab
        id="join-event-mic-cam-troubleshoots"
        data-testid="troubleshoot-link"
        href={t(getMicCamTroubleshootLink(os))}
        className={styles.link}
      >
        <Typography variant="h4" fontSize={16} fontWeight={700}>
          {t("micCamCheck:camera.mic.not.working")}
        </Typography>
      </Link>
      {!canChangeSpeakers && (
        <Link
          openInNewTab
          id="join-event-mic-cam-troubleshoot"
          href={t("url:troubleshoot.custom.speaker")}
          className={styles.link}
        >
          <Typography>{t("speaker.selection.not_working")}</Typography>
        </Link>
      )}
    </Container>
  );
};
